import { ConstructorInterfaceActionEncrypt } from '../../../../interface.type'
export default function EncryptActionInterface({ action }: {
    action: ConstructorInterfaceActionEncrypt
}) {

    return <div className='ActionInterface'>
        Encriptamos con {action.algorithm}
    </div>

}